import axios from 'axios'
const BASE_API_URL = process.env.REACT_APP_API_URL
export const GET_ADMIN_COUNT = `${BASE_API_URL}/Dashboard/GetAdminDashboard`

export function getAdminCountApi() {
  return axios.post(GET_ADMIN_COUNT)
}
